export { AWSSecretsManager, URL_SECRET_MANAGER } from './secretsManager'
